module.exports = __webpack_public_path__ + "img/zhuangshi.2caa5bc3.png";